import { render, staticRenderFns } from "./vehicleDetails.vue?vue&type=template&id=a31b6f82&scoped=true"
import script from "./vehicleDetails.vue?vue&type=script&lang=js"
export * from "./vehicleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31b6f82",
  null
  
)

export default component.exports